import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import ConfirmDialog from 'components/widgets/modal/ConfirmDialog';

const useStyle = makeStyles((theme) => ({
    highlightText: {
        color: theme.palette.text.red,
    },
    spacingBottom10: {
        paddingBottom: '10px',
    },
}));

const useCannotVoidRecordDialog = ({
    open = false,
    render = open,
    soldStocks = '',
    recordType = 'record',
    voidRecordType = recordType,
    onClose,
    onConfirm,
    disablePrimaryButton = false,
    additionalContent = null,
    dialogProps = {},
}) => {
    const classes = useStyle();
    const stockNumbers = String(soldStocks || '');

    const cannotVoidRecordDialog = render ? (
        <ConfirmDialog
            title={`The system cannot void this ${voidRecordType}`}
            open={open}
            variant="outlined"
            titlePrimary="Yes"
            titleSecondary="Cancel"
            onClose={onClose}
            onClickSecondary={onClose}
            onClickPrimary={onConfirm}
            disablePrimaryButton={disablePrimaryButton}
            {...dialogProps}
        >
            <div>
                <p className={classes.spacingBottom10}>
                    {`Some stock numbers in this ${recordType} have already been sold, and the associated deal(s) have been posted.
                    Voiding this ${voidRecordType} will not reverse them.`}
                </p>
                {stockNumbers.length > 0 && (
                    <p>
                        Stocks:
                        {' '}
                        {stockNumbers.split(',').filter(Boolean).join(', ')}
                    </p>
                )}
                <br />
                <p className={classes.spacingBottom10}>
                    {`To allow the system to reverse them correctly, please unpost the associated deal(s) before voiding this ${voidRecordType}.`}
                </p>
                <p className={clsx(classes.spacingBottom10, classes.highlightText)}>
                    If you continue without unposting the deal(s), any required financial reversal must be posted manually through a General Journal.
                </p>
                <p className={classes.spacingBottom10}>
                    {`Are you sure you want to void this ${voidRecordType}?`}
                </p>
            </div>
            {additionalContent}
        </ConfirmDialog>
    ) : null;

    return {
        cannotVoidRecordDialog,
    };
};

export default useCannotVoidRecordDialog;
